import { Warning } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

interface NoBestPerformerWarningProps {
  message?: string;
}

const NoBestPerformerWarning = ({
  message = "Not enough data to determine best performer"
}: NoBestPerformerWarningProps) => {
  return (
    <Tooltip title={message}>
      <Warning sx={{ color: "warning.main", fontSize: 20 }} />
    </Tooltip>
  );
};

export default NoBestPerformerWarning;
